import QRCodeStyling from "qr-code-styling";
import { CONFIG } from "../config";

export const deviceUtils = {
  isTracker: (deviceType) => {
    const trackerTypes = [1, 4, 7, 14, 15, 16, 41, 44];
    return trackerTypes.includes(deviceType);
  },

  getDeviceTypeLabel: (deviceType) => {
    const deviceTypeLabels = {
      1: "GPS Tracker",
      4: "Asset Tracker",
      7: "Vehicle Tracker",
      14: "Pet Tracker",
      15: "Personal Tracker",
      16: "Cargo Tracker",
      41: "Environmental Sensor",
      44: "IoT Device",
      // Add more device types as needed
    };
    return deviceTypeLabels[deviceType] || "Unknown Device";
  },

  getDeviceStatus: (device) => {
    if (!device.lastSeen) return "offline";

    const lastSeenDate = new Date(device.lastSeen);
    const now = new Date();
    const diffInMinutes = (now - lastSeenDate) / (1000 * 60);

    if (diffInMinutes < 30) return "online";
    if (diffInMinutes < 120) return "recent";
    return "offline";
  },

  formatDeviceName: (device) => {
    return device.name || device.deviceId || "Unnamed Device";
  },

  downloadQRCode: (claimCode, deviceName) => {
    // generate a QR code using the claim code and download it. print claim code at the bottom of the QR code
    const qrCode = new QRCodeStyling({
      width: 300,
      height: 300,
      margin: 20,
      imageSize: 0.6,
      type: "svg",
      data: claimCode,
      image: CONFIG.logo,
      dotsOptions: {
        color: "#4267b2",
        type: "rounded",
      },
      backgroundOptions: {
        color: "#e9ebee",
      },
      imageOptions: {
        crossOrigin: "anonymous",
        imageSize: 0.6,
      },
    });

    qrCode.append(document.getElementById("canvas"));
    qrCode.download({ name: deviceName, extension: "svg" });
  },
};
